import React from 'react';
import { AppBar, Toolbar, Typography, Box, Container } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

const Header = () => {
  return (
    <AppBar position="sticky" elevation={0}>
      <Container maxWidth="lg">
        <Toolbar sx={{ px: { xs: 1, sm: 2 } }}>
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              color: 'white',
              py: 1.5,
              '& svg': {
                filter: 'drop-shadow(0 0 10px rgba(76, 194, 255, 0.6))',
              }
            }}
          >
            <EmailIcon 
              fontSize="large" 
              sx={{ 
                mr: 2,
                color: theme => theme.palette.primary.main,
                fontSize: { xs: 28, sm: 32 }
              }} 
            />
            <Typography 
              variant="h5" 
              component="h1" 
              fontWeight="500"
              sx={{
                background: 'linear-gradient(45deg, #4cc2ff, #34d5eb)',
                backgroundClip: 'text',
                textFillColor: 'transparent',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                letterSpacing: '0.5px',
                fontSize: { xs: '1.2rem', sm: '1.5rem' }
              }}
            >
              Email Generator
            </Typography>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header; 